<style scoped>
    @keyframes x-progress-active {
        0% {
            opacity: 0.3;
            width: 0;
        }

        to {
            opacity: 0;
            width: 100%;
        }
    }
    @keyframes y-progress-active {
        0% {
            opacity: 0.3;
            height: 0;
        }

        to {
            opacity: 0;
            height: 100%;
        }
    }
    .bar {
        width: 100%;
        position: relative;
        display: flex;
    }
    .reverse {
        flex-direction: row-reverse;
    }
    .bar .value {
        height: 100%;
        position: relative;
        /* width: 0; */
    }
    .bar .value.x:before {
        content: "";
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        border-radius: 10px;
        animation: x-progress-active 2s ease-in-out infinite;
    }
    .bar .value.y:before {
        content: "";
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        border-radius: 10px;
        animation: y-progress-active 2s ease-in-out infinite;
    }
</style>
<template>
    <div :class="classes" :style="styles" class="bar">
        <div class="value" :class="barClass" ref="bar" :style="valueStyles"></div>
    </div>
</template>
<script>
    export default {
        props: {
            /** 线的宽度， */
            size: {
                default() {
                    return 12;
                }
            },
            mode: {
                validator(value) {
                    return ["x", "y"].indexOf(value) > -1;
                },
                default() {
                    return "y";
                }
            },
            align: {
                validator(value) {
                    return ["left", "right"].indexOf(value) > -1;
                },
                default() {
                    return "left";
                }
            },
            color: {
                default() {
                    return "#FFBB00";
                }
            },
            /** 扩展样式 */
            barStyle: {
                default() {
                    return {};
                }
            },
            backgroundColor: {
                type: String,
                default() {
                    return "rgba(255, 255, 255, 0.25)";
                }
            },
            isBackground: {
                type: Boolean,
                default: true
            },
            value: {
                validator(value) {
                    if (isNaN(value)) {
                        return false;
                    }
                    if (value < 0) {
                        return false;
                    }
                    return true;
                },
                default: 0
            },
            maxValue: {
                type: Number,
                default: 100
            }
        },
        data() {
            return {
                animation: true
            };
        },
        watch: {
            value(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.starAnimation();
                }
            },
            maxValue(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.starAnimation();
                }
            }
        },
        computed: {
            valueHW() {
                return this.mode == "y" ? "width" : "height";
            },
            classes() {
                return [
                    {
                        reverse: this.align == "right"
                    }
                ];
            },
            styles() {
                const style = {};
                if (this.mode == "y") {
                    style["height"] = `${this.size}px`;
                } else {
                    style["width"] = `100%`;
                    style["height"] = `100%`;
                    style["flexDirection"] = "column";
                    style["justifyContent"] = "flex-end";
                }
                if (this.isBackground) {
                    style["backgroundColor"] = this.backgroundColor;
                }

                return style;
            },
            valueStyles() {
                const style = {
                    ...this.barStyle,

                    background: this.color,
                    transition: this.animation
                        ? `${this.valueHW} 1s ease-out 0s`
                        : "none"
                };
                style[this.valueHW] = `0`;
                return style;
            },
            barClass() {
                const style = {
                    // y: this.mode == "x",
                    x: this.mode == "y"
                };
                return style;
            }
        },
        methods: {
            setBarWidth(val) {
                if( this.$refs.bar ){
                     this.$refs.bar.style[this.valueHW] = val ? val : (this.value / this.maxValue) * 100 + "%";
                }
            },
            starAnimation() {
                this.animation = false;
                this.setBarWidth(0);
                setTimeout(() => {
                    this.animation = true;
                    this.setBarWidth();
                }, 30);
            }
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.setBarWidth();
                }, 100);
            });
        }
    };
</script>
